module.exports = __webpack_public_path__ + "img/LogoDashboard-6.3636ca77.svg";